import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FullPageLayoutComponent } from './full-page-layout.component';

@NgModule({
  declarations: [FullPageLayoutComponent],
  imports: [CommonModule],
  exports: [FullPageLayoutComponent]
})
export class FullPageLayoutModule {}
